module.exports = __webpack_public_path__ + "media/images/textbaba_logo-39b063012c534bde3af7d9cf1607cba1.svg";